











































import { IPRCFiltersPayload, RateChangesState } from "@/models";
import RateChangesModule from "@/store/modules/rate-changes";
import RateChangeFilter from "@/views/rate-changes/filters/RateChangeFilter.vue";
import { namespace, State } from "vuex-class";
import { Component, Vue } from "vue-property-decorator";

const rateChanges = namespace(RateChangesModule.name);

@Component({
  name: "ChangeFilters",
  components: { RateChangeFilter }
})
export default class ChangeFilters extends Vue {
  // ===== Store ===== //
  @State("rateChanges") private rateChanges!: RateChangesState;
  @rateChanges.Action("applyIPRCFilters") private applyIPRCFilters!: (payload: IPRCFiltersPayload) => void;
  // ===== Data ===== //
  private filters: number[] = [];
  // ===== Methods ===== //
  private addFilter(): void {
    this.filters.push(Math.ceil(Math.random() * 100));
  }
  private removeFilter(id: number): void {
    this.filters = this.filters.filter(index => index !== id);
  }
  private handleApplyFilters(): void {
    const payload: IPRCFiltersPayload = {
      filters: this.rateChanges.appliedFilters,
      query: this.rateChanges.appliedFilters.map(filter => filter.query).join("&")
    };
    this.applyIPRCFilters(payload);
  }
}
